import {Brick, registerBrick} from 'olympe';

export default class GetFromJSObject extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} object
     * @param {string} property
     * @param {function(*)} setValue
     */
    update($, [object, property], [setValue]) {
        setValue(object[property]);
    }
}

registerBrick('0185303e54ac0e1c6858', GetFromJSObject);
